import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MensagensService } from '../mensagens/mensagens.service';

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
  constructor(private mensagensService: MensagensService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob && error.error.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const parsed = JSON.parse(reader.result as string);
              this.mensagensService.erro([parsed.message ?? 'Erro inesperado.']);
            } catch {
              this.mensagensService.erro(['Erro inesperado ao processar resposta.']);
            }
          };
          reader.readAsText(error.error);
        } else if (error.error?.message) {
          this.mensagensService.erro([error.error.message]);
        } else {
          this.mensagensService.erro(['Erro inesperado.']);
        }
        throw error;
      })
    );
  }
}
